import { Atom } from 'AppReact';
import styled, { css } from "styled-components";


const template = styled.div`
  ${({ theme, displayState }) => {
    return css`
    color: ${theme?.colour?.secondary ?? "#04333B"};
    font-weight: 600;
    font-size: 12px;
    text-decoration: underline;
    display: flex;
    align-items: center;
    padding: 0px;

    cursor: pointer;

    &:active {
      color: ${theme?.colour?.primary ?? "#1DBD6B"};
    }

    &:hover {
      color: ${!displayState?.disabled ? theme?.colour?.primary ?? "#1DBD6B" : ""};
    }

    ${displayState?.disabled && css`
      cursor: not-allowed;
      color: ${theme?.colour?.secondary ?? "#04333B"};
      opacity: .4;
      }
    `}
  `}
  }
`;


export default Atom({ type: 'button', dataType: 'string', template })
